import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import VisualHomepage from './components/VisualHomepage';
import LegalPerimeter from './components/LegalPerimeter';
import BeforeDeployment from './components/BeforeDeployment';
import ProgramsFramework from './components/ProgramsFramework';
import SupportScope from './components/SupportScope';
import CertificateProgramPreview from './components/CertificateProgramPreview';
import ProductLanes from './components/ProductLanes';
import HowItWorks from './components/HowItWorks';
import PlatformSection from './components/PlatformSection';
import TldIdentity from './components/TldIdentity';
import TokenizationLabWizard from './components/TokenizationLabWizard';
import IssuerFileStatus from './components/IssuerFileStatus';
import Pricing from './components/Pricing';
import DataRoom from './components/DataRoom';
import Networks from './components/Networks';
import SupportCTA from './components/SupportCTA';
import Footer from './components/Footer';
import SupportPage from './pages/SupportPage';
import BusinessDevelopmentPage from './pages/BusinessDevelopmentPage';
import ProgramRulesPage from './pages/ProgramRulesPage';
import FAQPage from './pages/FAQPage';

const HomePage = () => <VisualHomepage />;

const LegacyHomePage = () => (
  <>
    <main className="visual-legacy pt-32">
      <BeforeDeployment />
      <ProgramsFramework />
      <SupportScope />
      <LegalPerimeter />
      <CertificateProgramPreview />
      <ProductLanes />
      <HowItWorks />
      <PlatformSection />
      <TldIdentity />
      <TokenizationLabWizard />
      <IssuerFileStatus />
      <Pricing />
      <DataRoom />
      <Networks />
      <SupportCTA />
    </main>
    <Footer />
  </>
);

const ApplyPage = () => (<><Navbar /><main className="pt-24"><TokenizationLabWizard /></main><Footer /></>);

function App() {
  return (
    <BrowserRouter>
      <div className="App min-h-screen bg-background scroll-smooth">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/legacy" element={<><Navbar /><LegacyHomePage /></>} />
          <Route path="/business-development" element={<><Navbar /><BusinessDevelopmentPage /><Footer /></>} />
          <Route path="/program-rules" element={<><Navbar /><ProgramRulesPage /><Footer /></>} />
          <Route path="/faq" element={<><Navbar /><FAQPage /><Footer /></>} />
          <Route path="/apply" element={<ApplyPage />} />
          <Route path="/support" element={<><Navbar /><SupportPage /></>} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
